import StakeConfirmationModal from './StakeConfirmationModal';

export default StakeConfirmationModal;

